import styles from "../../Styles/DropdownMenuItems.module.css";
const DropdownMenuItem = ({ option, selectedOption }) => {
  const selectedHandler = () => {
    selectedOption(option);
  };
  return (
    <li className={styles.item} onClick={selectedHandler}>
      <p className={styles.item__text}>{option}</p>
    </li>
  );
};
export default DropdownMenuItem;
